import h from 'react-hyperscript';
import { Link } from 'react-router';
import classnames from 'classnames';
import styles from './cta.css';

const Cta = ({ href, children, className, to }) =>  (
  h(Link, { className: classnames(className, styles.cta), href, to }, children)
);

export default Cta;


/** WEBPACK FOOTER **
 ** ./src/Cta/index.js
 **/